/**
 * Convert presentation slides to PowerPoint format, in the browser.
 */ import { renderPptx } from './pptx-renderer';
/**
 * Convert slides to a PowerPoint file. Returns a Blob that can be downloaded.
 *
 * This used to POST to /api/presentation/export. That endpoint was a pure
 * function — it received the same {title, slides, theme} this already has, and
 * read nothing else — so the deck is built here instead. The rendering code is
 * the express handler's, moved verbatim; pptxgenjs is loaded on demand inside
 * renderPptx so it only reaches viewers who export.
 */ export async function convertToPptx({ title, slides, theme = 'federal-navy' }) {
    return renderPptx(title, slides, theme);
}
/**
 * Trigger download of PPTX file
 */ export function downloadPptx(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename.endsWith('.pptx') ? filename : `${filename}.pptx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
